<template>
	<b-sidebar
		:visible="isVisible"
		id="previewBar"
		lazy
		width="100%"
		@hidden="isVisible = false"
	>
		<!-- title -->
		<b-row>
			<b-col
				cols="10"
				offset="1"
				offset-md="3"
				md="6"
				offset-lg="3"
				lg="6"
				offset-xl="4"
				xl="4"
				class="text-center mb-4"
			>
				<h2 class="text-body">{{ attachment.title }}</h2>
			</b-col>
		</b-row>

		<!-- attachments image -->
		<b-row>
			<b-col
				cols="12"
				sm="12"
				md="12"
				offset-lg="2"
				lg="8"
				offset-xl="3"
				xl="6"
				class="text-center position-relative"
			>
				<b-img
					:src="attachment.path"
					:alt="attachment.title"
					fluid
					thumbnail
				></b-img>

				<!-- coruasel control buttons  -->
				<!-- prev -->
				<a
					class="carousel-control-prev text-primary"
					href="#"
					role="button"
					data-slide="prev"
					@click.prevent="showAttachment('prev')"
				>
					<span
						class="carousel-control-prev-icon fontIcon"
						aria-hidden="true"
					></span>
					<span class="sr-only">Previous</span>
				</a>
				<!-- next -->
				<a
					class="carousel-control-next"
					href="#"
					role="button"
					data-slide="next"
					@click.prevent="showAttachment('next')"
				>
					<span
						class="carousel-control-next-icon fontIcon"
						aria-hidden="true"
					></span>
					<span class="sr-only">Next</span>
				</a>
			</b-col>
		</b-row>

		<!-- comment -->
		<b-row>
			<b-col
				cols="10"
				offset="1"
				offset-lg="2"
				lg="8"
				offset-xl="2"
				xl="8"
				class="my-4"
			>
				<div
					v-if="attachment.comment !== null"
					class="bg-white rounded p-3 text-body d-flex align-items-cente"
				>
					<font-awesome-icon size="lg" :icon="['fas', 'comment']" />
					<p class="mx-3 mb-0">{{ attachment.comment }}</p>
				</div>
			</b-col>
		</b-row>

		<!-- close button -->
		<b-row>
			<b-col
				cols="10"
				offset="1"
				offset-lg="2"
				lg="8"
				offset-xl="2"
				xl="8"
				class="my-4"
			>
				<div class="text-right">
					<b-button
						@click.prevent="isVisible = false"
						class="border-0"
						variant="outline-success"
					>
						<font-awesome-icon :icon="['fas', 'eye-slash']" />
						&nbsp;close me</b-button
					>
				</div>
			</b-col>
		</b-row>
	</b-sidebar>
</template>
<script>
	export default {
		name: "attachmentSideBarShow_component",
		props: {
			attachment: {
				type: Object,
				default: () => ({
					title: null,
					path: null,
					comment: null,
				}),
			},

			previewBarVisible: {
				type: Boolean,
				default: () => true,
			},
		},

		computed: {
			isVisible: {
				get() {
					return this.previewBarVisible;
				},
				set() {
					this.$emit("closeMe");
				},
			},
		},

		// by click on the next/prev button pass it to parent to show next/prev attachment
		methods: {
			showAttachment(direction) {
				this.$emit("showAttachment", direction);
			},
		},
	};
</script>

<style lang="scss">
	// next / prev arrow
	.fontIcon {
		height: 50px;
		width: 50px;
	}
</style>